import promiseMiddleware from 'redux-promise-middleware'

export default promiseMiddleware({
  promiseTypeSuffixes: ['LOADING', 'SUCCESS', 'ERROR'],
})



// WEBPACK FOOTER //
// ./src/application/middleware/promiseMiddleware.js